// eslint-disable-next-line import/no-extraneous-dependencies, n/no-extraneous-import
import emojiRegex from 'emoji-regex';
import getFrontConfig from '../getFrontConfig';

const {
  documentTypeValidation: { regexByDocumentType },
  countryCode,
} = getFrontConfig();

const getFirstCapturingGroup = (regex, str) => {
  const res = regex.exec(str);
  return res && res.length > 1 ? res[1] : null;
};

/**
 * Get regex by documentType and country
 * @param {string} selectedDocumentType
 * @return {string} regex
 */
const getRegexByDocumentType = (selectedDocumentType) => {
  const regexByCountry = regexByDocumentType?.[countryCode];
  // Use the regex defined for the selected value in the json
  // Or use a default regex
  const currentRegex =
    selectedDocumentType && regexByCountry?.[selectedDocumentType];
  if (currentRegex) return currentRegex;
  return regexByCountry?.default || regexByDocumentType?.default || '[0-9]+';
};

/**
 * Remove all emoji in string
 * @param {string} str
 * @return {string} out string
 */
const removeEmoji = (str) => {
  const regex = emojiRegex();
  return str.replace(regex, '');
};

export { getFirstCapturingGroup, getRegexByDocumentType, removeEmoji };
